import { Comment } from "@/components/comments/Comment.tsx";
import { FileItem } from "@/components/files/FileItem.tsx";
import { FormResultForEmployeeProps } from "@/components/form-result/result-modal/components/types.ts";
import { ApiFile } from "@/types/common.types.ts";
import { Stack, Text, Title, useToasts } from "@skailer-com/uikit";
import { MouseEvent } from "react";
import { useTranslation } from "react-i18next";

interface ResultFilesProps {
  files: ApiFile[];
}

export const ResultFiles = ({ files }: ResultFilesProps) => {
  const { t } = useTranslation();
  const { showError } = useToasts();

  const openFile = async (file: ApiFile) => {
    if (!file.url_permanent) {
      showError({ title: t("surveys:file_result_open_error") });
      return;
    }

    window.open(file.url_permanent, "_blank", "noopener,noreferrer");
  };

  const stopPropagation = (event: MouseEvent<HTMLDivElement>) => event.stopPropagation();

  if (files.length === 0) {
    return <Text className="text-secondary">{t("surveys:file_result_empty")}</Text>;
  }

  return (
    <Stack gap="sm" onClick={stopPropagation}>
      {files.map((file) => (
        <FileItem key={file.uuid} file={file} onOpenFile={openFile} />
      ))}
    </Stack>
  );
};

export const FileElementResult = ({ element, answer }: FormResultForEmployeeProps) => {
  const { t } = useTranslation();
  const settings = element.file_settings;

  if (!settings) return null;

  return (
    <Stack gap="md">
      <Title
        header={settings.title || t("surveys:question_type_file")}
        size="sm"
        paddingTop={true}
        className={settings.title ? "" : "text-secondary"}
      />
      <ResultFiles files={answer?.answer_files ?? []} />
      {answer?.comment && <Comment text={answer.comment} employee={null} isShort={false} />}
    </Stack>
  );
};
